import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Profile", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "text-xl font-bold mb-4" }, "Upload your CV", -1)
const _hoisted_3 = { class: "flex flex-col items-center space-y-3 pb-3" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-grow" }, null, -1)
const _hoisted_5 = { class: "sticky flex bottom-0 z-10 w-full p-2 bg-white shadow-md dark:bg-primary-black" }

import { ref, computed, onMounted } from "vue"
  import { useAccountStore } from "@/store/account"
  import { useUserStore } from "@/store/user"
  import { useResourcesStore } from "@/store/resources"
  import { generateSchema } from "@/utils/validate"
  import { arrowBackCircle } from "ionicons/icons"
  import { IonBackButton, IonLoading, IonButton } from "@ionic/vue"
  import { DocumentArrowUpIcon } from "@heroicons/vue/24/solid"
  import jwt from "@/utils/jwt"
  import router from "@/router"

  import CardTemplate from "@/components/template/CardTemplate.vue"
  import WbInput from "@/components/template/InputTemplate.vue"
  import SelectTemplate from "@/components/template/SelectTemplate.vue"
  import PhoneTemplate from "@/components/template/PhoneTemplate.vue"
  import FormTemplate from "@/components/template/formTemplate.vue"
  import UploadTemplate from "@/components/template/UploadTemplate.vue"

  // initialize stores
  
export default /*#__PURE__*/_defineComponent({
  __name: 'UploadCV',
  setup(__props) {

  const userStore = useUserStore()

  // initilize resources
  const nbf = ref(jwt.generateNBF())
  const profile = computed<any>({
    get: () => userStore.customerDetails.profile,
    set: (val) => userStore.setCustomerDetails({ profile: val }),
  })
  const input = ref({
    uploaded_cv: "",
  })

  const cvDetails = computed(() => ({
    uploaded_cv: profile.value.uploaded_cv,
  }))
  const cvSchema = generateSchema([
    {
      name: "cv",
      rule: "stringOptional",
    },
  ])

  /**
   * save action
   */
  const saveAction = () => {
    const cvForm = document.getElementById("cvForm")
    if (cvForm) cvForm
  }

  /**
   * Saves uploaded cv
   */
  const saveUploadedCV = () => {
    profile.value.uploaded_cv = input.value.uploaded_cv
    const cvData = {
      profile: {
        uploaded_cv: profile.value.uploaded_cv,
      },
    }
    userStore.saveCustomerDetails(nbf.value, cvData)
    userStore.retrieveProfileDetails("cv")
  }

  /**
   * call initialize
   */
  onMounted(() => {
    userStore.retrieveProfileDetails("cv")
    input.value = {
      ...input.value,
      ...cvDetails.value,
    }
  })

return (_ctx: any,_cache: any) => {
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_content = _resolveComponent("ion-content")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ion_header, null, {
      default: _withCtx(() => [
        _createVNode(_component_ion_toolbar, null, {
          default: _withCtx(() => [
            _createVNode(_component_ion_buttons, null, {
              default: _withCtx(() => [
                _createVNode(_unref(IonBackButton), {
                  class: "text-gray-300 pl-3",
                  text: ``,
                  icon: _unref(arrowBackCircle)
                }, null, 8, ["icon"]),
                _hoisted_1
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_ion_content, null, {
      default: _withCtx(() => [
        _createVNode(FormTemplate, {
          "validation-schema": _unref(cvSchema),
          "initial-values": JSON.parse(JSON.stringify(_unref(cvDetails))),
          class: "flex flex-col min-h-screen",
          onValid: saveUploadedCV
        }, {
          default: _withCtx(() => [
            _createVNode(CardTemplate, { class: "mx-4 my-6" }, {
              default: _withCtx(() => [
                _hoisted_2,
                _createVNode(UploadTemplate, {
                  id: 'cv_file',
                  modelValue: input.value.uploaded_cv,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((input.value.uploaded_cv) = $event)),
                  name: "uploaded_cv",
                  accepts: ".pdf",
                  folder: "file",
                  type: "primary",
                  class: "h-[150px] w-full",
                  "input-placeholder": "Upload PDF",
                  "border-dashed": true
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_3, [
                      _createVNode(_unref(DocumentArrowUpIcon), { class: "w-10 text-white" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_unref(IonButton), {
                expand: "block",
                color: "white",
                type: "submit",
                "native-type": "submit",
                class: "text-white bg-primary-violet font-bold rounded-[4px] shadow-base w-full"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Save")
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["validation-schema", "initial-values"])
      ]),
      _: 1
    })
  ], 64))
}
}

})